export type DeleteEmailDialogTranslation = {
  button: {
    cancel: string;
    ok: string;
  };
  content: string;
  title: string;
};

export const deleteEmailDialogTranslation: DeleteEmailDialogTranslation = {
  button: {
    cancel: 'Anuluj',
    ok: 'Usuń',
  },
  content: 'Czy na pewno chcesz usunąć wiadomość od ',
  title: 'Usuń email',
};

export type ThreadEmailsTranslation = {
  dialog: {
    attachToExistingProcess: {
      button: {
        cancel: string;
        save: string;
      };
      form: {
        process: string;
      };
      title: string;
      tooltip: {
        addToProcess: string;
        goToProcess: string;
      };
    };
    attachToExistingTask: {
      button: {
        cancel: string;
        save: string;
      };
      form: {
        process: string;
      };
      title: string;
      tooltip: {
        addToTask: string;
        goToTask: string;
      };
    };
    deleteEmail: DeleteEmailDialogTranslation;
    newProcess: {
      matchContact: string;
      matchEmail: string;
      matchOwner: string;
      defaultDataError: string;
      noContactMatch: string;
      selectMatch: string;
    };
  };
  email: {
    summary: {
      button: {
        copy: string;
      };
      cc: string;
      draft: string;
      editDraft: string;
      emailCopiedConfirmation: string;
      subject: string;
      to: string;
    };
  };
  header: {
    button: {
      goToProcess: string;
      goToTask: string;
    };
    toProcess: ToResourceTranslation;
    toTask: ToResourceTranslation;
  };
  noEmailSelected: string;
};

type ToResourceTranslation = {
  button: {
    attachToExisting: string;
    openMenu: string;
    startNew: string;
  };
};

export const threadEmailsTranslation: ThreadEmailsTranslation = {
  dialog: {
    attachToExistingProcess: {
      button: {
        cancel: 'Anuluj',
        save: 'Zapisz',
      },
      form: {
        process: 'Wybierz process',
      },
      title: 'Dołączanie wiadomości do istniejącego procesu',
      tooltip: {
        addToProcess: 'Dodaj do istniejącego procesu',
        goToProcess: 'Przejdź do procesu',
      },
    },
    attachToExistingTask: {
      button: {
        cancel: 'Anuluj',
        save: 'Zapisz',
      },
      form: {
        process: 'Wybierz zadanie',
      },
      title: 'Dołączanie wiadomości do istniejącego zadania',
      tooltip: {
        addToTask: 'Dodaj do istniejącego zadania',
        goToTask: 'Przejdź do zadania',
      },
    },
    deleteEmail: deleteEmailDialogTranslation,
    newProcess: {
      matchContact: 'Kontakt',
      matchEmail: 'Email',
      matchOwner: 'Opiekun',
      defaultDataError: 'Nie udało się pobrać dopasowań dla tego wątku.',
      noContactMatch: 'Nie znaleziono kontaktu przypisanego do klienta.',
      selectMatch: 'Wybierz dopasowanie',
    },
  },
  email: {
    summary: {
      button: {
        copy: 'Kopiuj',
      },
      cc: 'Kopia',
      draft: 'Szkic',
      editDraft: 'Szkic',
      emailCopiedConfirmation: 'Adres skopiowany do schowka',
      subject: 'Temat',
      to: 'Do',
    },
  },
  header: {
    button: {
      goToProcess: 'Przejdź do procesu',
      goToTask: 'Przejdź do zadania',
    },
    toProcess: {
      button: {
        attachToExisting: 'Do istniejącego',
        openMenu: 'Dodaj do procesu',
        startNew: 'Do nowego',
      },
    },
    toTask: {
      button: {
        attachToExisting: 'Do istniejącego',
        openMenu: 'Dodaj do zadania',
        startNew: 'Do nowego',
      },
    },
  },
  noEmailSelected: 'Wybierz wątek lub wiadomość do przeczytania',
};
